<template>
  
  <v-flex xs12 sm12 md12 class="negativeTopbarMargin">

    <v-parallax height=200 :src="require('@/assets/parallax.jpeg')">
      <v-layout align-center column justify-center>
        <h1 class="display-3 font-weight-thin mb-3">Turing Form</h1>
        <h4 class="subheading text-xs-center">Simple and free form/survey for anything.</h4>
        <span><router-link to="/" class="white--text">TuringForm</router-link></span>
      </v-layout>
    </v-parallax>

    <v-container v-if="!render">
      <v-layout row wrap>
        <v-flex xs12 md12 class="text-xs-center my-5">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>

    <v-form v-if="render" v-model="valid" ref="form">
      <v-container>
        <v-layout row wrap>

          <v-flex xs12 md12 class="text-xs-center my-5">
            <v-btn color="info" large @click="googleAuth">Sign in with Google</v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-form>

    <v-divider></v-divider>

    <v-container v-if="render">
      <v-layout row wrap>
        <v-flex xs12 md12 class="ma-5 text-xs-center">
          <h1 class="headline mb-0">Don't have account?</h1>
          <v-btn large color="success" @click="googleAuth">Sign up with google</v-btn> 
        </v-flex>
      </v-layout>
    </v-container>

  </v-flex>

</template>

<script>
// @ is an alias to /src

export default {
  name: "login",
  components: {
  },
  props: {},
  data: () => ({
    valid: false,
    render: false,
    rules: {
      required: value => !!value || 'Cannot Be Empty.',
      min: v => v.length >= 8 || 'Min 8 characters',
      emailMatch: () => ('The email and password you entered don\'t match')
    }
  }),
  computed: {},
  watch: {},
  created(){

    firebase.auth()
    .onAuthStateChanged((user)=> {
      if (user) {
        this.$router.push('/');
      } else {
        this.render = true;
      }
    });

    
    firebase.auth().getRedirectResult().then((result)=> {
      if (result.credential) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
      }
      // The signed-in user info.
      var user = result.user;

      // Auth success. Go home.
      if (user) { return this.$router.push('/');}
      
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      console.log(error)
      // ...
    });
    
  },
  mounted(){},
  methods: {

    googleAuth() {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    }
  }
};
</script>

<style scoped>

button {
  width:250px;
}

</style>